/** Packages **/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CalendarActivitiesRow from './CalendarActivitiesRow';
import CalendarActivity from './CalendarActivity';
import * as utilities from './../../utilities/calendarUtilities';
import * as actions from './../../data/linearCalendar/actions';
import { updateCalendarWidth, scrolling } from './helpers';
import { STATION_ID } from '../../data/constants';
import { useLanguage } from '../../context/LanguageContext';
import './styles.scss';

class CalendarActivities extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activities: []
    };
  }
  componentDidMount() {
    window.addEventListener('scroll', () => scrolling());
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ activities: nextProps.activities });
    const calendarElement = document.querySelector('.Calendar-Wrapper');
    updateCalendarWidth(calendarElement);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', () => scrolling());
  }
  updateActivities = activity => {
    const { updateActivity } = this.props;
    updateActivity(activity);
  };

  handleVacationExtraDays = extraId => {
    const { updateActivity } = this.props;

    const vacationDays = this.state.activities.find(
      activity => activity.type === 'VAC'
    );
    const extradays = this.state.activities.filter(
      activity => activity.type === 'VAE'
    );

    let extraday = extradays.find(day => {
      return day.activityId === extraId;
    });

    let requestBody = {
      activityId: vacationDays.activityId,
      date: extraday.startDate
    };

    return fetch(`api/activities/preassignments/update/activitieId`, {
      method: 'POST',
      body: JSON.stringify({
        request: requestBody
      })
    })
      .then(res => res.json())
      .then(json => {
        json.activities.map(activity => updateActivity(activity));
      });
  };

  render() {
    const commonLabels = this.props.labels?.commonLabels || {};
    const {
      activities,
      categoryId,
      bidSession,
      bidSessionId,
      staffId,
      handleActionPreference,
      showNotification,
      bidSessionStartDate,
      calendarHourWidth,
      calendarStartDateStr
    } = this.props;

    const container = this.props.containerWidth;
    let calendarRowActivities;
    const isLowLabel = false;
    const calendarStartDateTs = new Date(calendarStartDateStr).getTime();

    if (activities) {
      const filteredActivities = activities.filter(activity => {
        // Remove all the non-editable activities prior the start of planning session
        if (
          calendarStartDateTs >= activity.endDate &&
          !activity.isVacationEditable
        ) {
          return false;
        }
        // Remove all the non-editable declined vacations
        if (
          activity.startDate === activity.endDate &&
          !activity.isVacationEditable
        ) {
          return false;
        }
        return true;
      });

      calendarRowActivities = filteredActivities.map((activity, i) => {
        let activityStartDateTs = activity.startDate;
        let activityEndDateTs = activity.endDate;
        let type;
        if (typeof activity.type !== 'string') {
          type = activity.type === 132 ? 'TRP' : 'RSV';
        } else {
          type = activity.type;
        }

        if (calendarStartDateTs >= activityEndDateTs) {
          // Activity ends prior the start of the calendar
          activityStartDateTs = calendarStartDateTs;
          activityEndDateTs = calendarStartDateTs;
        } else if (calendarStartDateTs > activityStartDateTs) {
          // Activity starts prior the calendar but ends inside the planning session
          activityStartDateTs = calendarStartDateTs;
        }

        const hoursFromCalendarStart = utilities.getHourDiff(
          calendarStartDateTs,
          activityStartDateTs
        );
        const leftFromCalendarStartPx =
          calendarHourWidth * hoursFromCalendarStart;
        const activityDurationInHours = utilities.getHourDiff(
          activityStartDateTs,
          activityEndDateTs
        );

        const activityLengthPx = activityDurationInHours * calendarHourWidth;
        const myKey = i;
        const userStationId = this.props.bidSession.user.currentCategory.stationId;
        return (
          <CalendarActivity
            activity={activity}
            active={activity.active}
            activityType={type}
            categoryId={categoryId}
            bidSession={bidSession}
            bidSessionId={bidSessionId}
            bidSessionStartDate={bidSessionStartDate}
            staffId={staffId}
            key={myKey}
            activityId={activity.activityId}
            type={activity.name ? activity.name : type}
            backgroundColor={this.props.types.get(type)}
            borderColor={activity.borderColor ? activity.borderColor : false}
            opacity={activity.addedByUser ? 0.5 : 1}
            displayNone={this.props.reportMode && activity.addedByUser}
            length={activityDurationInHours}
            startDateRaw={activity.startDate}
            endDateRaw={activity.endDate}
            isLowLabel={isLowLabel}
            vacationSlideStartDate={activity.vacationSlideStartDate}
            vacationSlideEndDate={activity.vacationSlideEndDate}
            isVacationEditable={activity.isVacationEditable}
            originalStartDate={activity.originalStartDate}
            originalEndDate={activity.originalEndDate}
            validatedVacationSlideStartDate={
              activity.validatedVacationSlideStartDate
            }
            validatedVacationSlideEndDate={
              activity.validatedVacationSlideEndDate
            }
            handleActionPreference={handleActionPreference}
            handleVacationExtraDays={this.handleVacationExtraDays}
            showNotification={showNotification}
            updateActivities={this.updateActivities}
            activityWidth={activityLengthPx}
            calendarStartDateStr={calendarStartDateStr}
            calendarHourWidth={calendarHourWidth}
            leftPosition={leftFromCalendarStartPx}
            stationId={
              sessionStorage.getItem('admin') === commonLabels.ADMIN
                ? sessionStorage.getItem(STATION_ID)
                : userStationId
            }
            removeActivity={this.props.removeActivity}
            bidPreferencesTotalEntries={this.props.bidPreferencesTotalEntries}
            reportMode={this.props.reportMode}
            setFromAddButton={this.props.setFromAddButton}
          />
        );
      });
    }
    return (
      <div
        className={!this.props.reportMode ? 'Calendar-Activities-Wrapper' : 'Calendar-Activities-Wrapper-Report'}
        style={{ minWidth: container, ...(this.props.reportMode && { marginTop: '-32px' }) }}
      >
        <CalendarActivitiesRow
          activities={calendarRowActivities}
          containerWidth={container}
        />
      </div>
    );
  }
}

CalendarActivities.propTypes = {
  activities: PropTypes.array,
  types: PropTypes.any.isRequired,
  containerWidth: PropTypes.number.isRequired,
  stationId: PropTypes.string,
  categoryId: PropTypes.number.isRequired,
  bidSession: PropTypes.object.isRequired,
  bidSessionId: PropTypes.number.isRequired,
  staffId: PropTypes.string.isRequired,
  handleActionPreference: PropTypes.func.isRequired,
  showNotification: PropTypes.func.isRequired,
  removeActivity: PropTypes.func.isRequired,
  updateActivity: PropTypes.func.isRequired,
  bidSessionStartDate: PropTypes.array.isRequired,
  calendarStartDateStr: PropTypes.any,
  calendarEndDateStr: PropTypes.any,
  calendarHourWidth: PropTypes.number,
  bidPreferencesTotalEntries: PropTypes.func.isRequired,
  fetchActivities: PropTypes.func.isRequired,
  reportMode: PropTypes.bool.isRequired
};

CalendarActivities.defaultProps = {
  activities: [],
  calendarStartDateStr: null,
  calendarEndDateStr: null,
  calendarHourWidth: 0,
  stationId: '',
  reportMode: false
};

const mapStateToProps = state => ({
  ...state.calendarActivities,
  ...state.login.user.currentCategory
});

const mapDispatchToProps = dispatch => ({
  fetchActivities: (staffId, startDate, endDate, bidSessionId, categoryId) =>
    dispatch(
      actions.default.fetchActivities(
        staffId,
        startDate,
        endDate,
        bidSessionId,
        categoryId
      )
    )
});

const ConnectedCalendarActivities = connect(mapStateToProps, mapDispatchToProps)(CalendarActivities);

function CalendarActivitiesWrapper(props) {
  const { labels } = useLanguage();
  return <ConnectedCalendarActivities {...props} labels={labels} />;
}

export default CalendarActivitiesWrapper;
